import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";

const ElectronicSignature3 = ({ onClose, onConfirm }) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [agreed, setAgreed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [userName, setUserName] = useState("의뢰인");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [userData, setUserData] = useState(null);

  // 페이지 로드 시 모달이 하단에서 올라오도록 설정
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = Cookies.get(
          API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN
        );

        if (!token) {
          throw new Error("인증 토큰이 없습니다. 다시 로그인해주세요.");
        }

        const response = await fetch(`${API_ENDPOINTS.BASE_URL}/clients/me`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("사용자 정보를 가져오는데 실패했습니다.");
        }

        const data = await response.json();
        setUserData(data);
      } catch (err) {
        setError(err.message || "사용자 정보를 가져오는데 실패했습니다.");
      } finally {
        setVisible(true);
      }
    };

    fetchUserData();
  }, []);

  // 모달 닫기 처리
  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  // 동의 처리
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const modalVariants = {
    hidden: {
      y: "100%",
      opacity: 1,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 300,
      },
    },
    exit: {
      y: "100%",
      opacity: 1,
      transition: {
        duration: 0.3,
      },
    },
  };

  return (
    <ModalOverlay onClick={handleClose}>
      <AnimatePresence>
        {visible && (
          <ModalContainer
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <ModalHeader>
              <ModalTitle>이용약관</ModalTitle>
              <CloseButton onClick={handleClose}>&times;</CloseButton>
            </ModalHeader>
            <ModalBody>
              <SectionContainer>
                <TermsTitle>
                  <strong>이용약관_성난 유심 피해자들</strong>
                </TermsTitle>

                <IntroText>
                  성난 유심 피해자들을 이용해주시는 모든 분들께 감사드립니다.
                  아래 약관은 저희의 서비스를 이용하는 여러분 모두에게 적용되니
                  시간을 내어 확인해주세요.
                </IntroText>

                <Section>
                  <SectionTitle>제1장 총칙</SectionTitle>

                  <ArticleTitle>제1조 (목적)</ArticleTitle>
                  <SectionContent>
                    이 약관은 법무법인 더 에이치 황해(이하 '더 에이치 황해')가
                    성난 유심 피해자들 사이트와 앱을 통해 제공하는 모든
                    서비스(이하 '서비스')의 이용조건 및 절차, 이용자와 사이트의
                    권리, 의무, 책임사항과 기타 필요한 사항을 정합니다.
                  </SectionContent>

                  <ArticleTitle>제2조 (약관의 효력과 변경)</ArticleTitle>
                  <SectionContent>
                    ① 이 약관은 더 에이치 황해가 운영하는 성난 유심 피해자들
                    사이트 및 앱에 게시함으로써 효력이 발생합니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 여러분이 이 약관의 내용에 동의하는 것을
                    조건으로 서비스를 제공합니다. 서비스 제공 및 이용과 관련하여
                    이 약관이 우선적으로 적용됩니다.
                    <br />
                    <br />
                    ③ 더 에이치 황해는 약관을 변경할 수 있으며, 변경된 약관은
                    사이트 및 앱 내에 게시함으로써 효력이 발생합니다.
                    <br />
                    <br />④ 더 에이치 황해가 약관을 변경할 때에는 시행 일자를
                    명시하여 그 시행일자 30일 전부터 사이트 및 앱 내에
                    게시합니다. 변경된 약관에 동의하지 않는 회원의 경우
                    회원탈퇴를 할 수 있고, 회원탈퇴를 하지 않은 경우에는 변경된
                    약관에 동의하는 것으로 간주합니다.
                  </SectionContent>
                </Section>

                <Section>
                  <SectionTitle>제2장 서비스 제공 및 이용</SectionTitle>

                  <ArticleTitle>
                    제3조 (이용계약의 성립 및 이용계약상 지위의 양도)
                  </ArticleTitle>
                  <SectionContent>
                    ① 여러분이 더 에이치 황해가 제공하는 가입 절차에 따라 사이트
                    또는 앱에 가입하시면 여러분과 더 에이치 황해 사이에
                    이용계약이 성립합니다. 이에 따라 이용계약이 성립한 서비스
                    이용자를 "회원"이라 합니다.
                    <br />
                    <br />
                    ②더 에이치 황해는 다음 각 호에 해당하는 이용계약에 대하여
                    가입을 취소할 수 있습니다.
                    <br />
                    1. 다른 사람의 명의를 사용하여 가입하였을 때
                    <br />
                    2. 가입 시 요구되는 정보의 내용을 허위로 기재하였을 때
                    <br />
                    3. 사회의 안녕 질서 혹은 미풍양속을 저해할 의도로 가입하였을
                    때
                    <br />
                    4. 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는
                    등의 행위를 하였을 때
                    <br />
                    5. 서비스를 이용하면서 법령 또는 이 약관이 금지하는 행위를
                    하였을 때
                    <br />
                    6. 기타 더 에이치 황해가 정한 가입요건이 충족되지 않았을 때
                    <br />
                    <br />
                    ③ 더 에이치 황해는 다음 각 호에 해당하는 경우에는 그 사유가
                    해소될 때까지 가입을 유보할 수 있습니다.
                    <br />
                    1. 기술상의 장애사유로 인한 서비스 중단의 경우
                    <br />
                    2. 전기통신사업법에 의한 기간통신사업자가 전기통신 서비스를
                    중지하는 경우
                    <br />
                    3. 전시. 사변, 국가 비상사태 또는 이에 준하는 천재지변이
                    발생하거나 발생할 우려가 있는 경우
                    <br />
                    4. 긴급한 시스템 점검, 증설 및 교체설비의 보수 등을 위하여
                    부득이한 경우
                    <br />
                    5. 서비스 설비 장애, 서비스 이용의 폭주 등 서비스를 제공할
                    수 없는 사유가 발생한 경우
                    <br />
                    6. 기타 더 에이치 황해가 재정적, 기술적으로 필요하다고
                    판단하는 경우
                    <br />
                    <br />④ 회원은 서비스 이용계약상의 지위, 서비스 이용 권한을
                    다른 사람에게 대여, 양도, 증여하거나 담보로 제공할 수
                    없습니다.
                  </SectionContent>

                  <ArticleTitle>제4조 (서비스 제공 및 중단 등)</ArticleTitle>
                  <SectionContent>
                    ① 이용계약이 성립되면 회원은 더 에이치 황해가 제공하는
                    서비스를 자유롭게 이용할 수 있습니다. 다만, 일부 서비스의
                    경우 본인확인, 개인정보수집 및 제3자 제공 동의 등 별도의
                    절차를 완료하여야 이용이 가능할 수 있습니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 회원에게 서비스를 제공하기 위해 최선의
                    노력을 다합니다. 다만, 정상적으로 서비스를 제공하기 어려운
                    사정이 발생하여 일시적이거나 영구적으로 서비스를 전부
                    중단하여야 할 경우에는 중단일로부터 1주일 전에 사이트 내에
                    그 사유를 게시하고 서비스를 중단할 수 있습니다. 부득이한
                    사정이 있을 경우 위 사전 게시기간은 감축되거나 생략될 수
                    있습니다.
                    <br />
                    <br />
                    ③ 제2항에서 정한 서비스 중단에 의하여 더 에이치 황해에 보관
                    또는 전송된 정보의 내용이 보관되지 못하였거나 삭제된 경우,
                    전송되지 못한 경우 및 기타 통신 데이터의 손실이 발생하는
                    경우 더 에이치 황해는 회원 또는 제3자에게 책임을 지지
                    않습니다.
                    <br />
                    <br />
                    ④ 더 에이치 황해는 더 나은 서비스 제공을 위하여 회원 정보에
                    등록되어 있는 연락처로 서비스에 관한 안내 사항을 발송할 수
                    있습니다. 단, 광고성 정보는 사전에 수신 동의한 회원에게만
                    발송됩니다.
                    <br />
                    <br />
                    ⑤ 더 에이치 황해는 서비스의 본 약관의 내용에 위배되는 행동을
                    한 회원에 대하여 임의로 서비스 사용을 제한하거나 사이트 및
                    앱에 대한 접속을 금지할 수 있습니다.
                    <br />
                    <br />⑥ 사이트 또는 앱에 장기간 접속을 하지 않은 회원의 경우
                    이메일 또는 공지사항 등을 통한 안내 후 검토 기간을 거쳐
                    서비스 이용을 중지 또는 가입을 취소할 수 있습니다.
                  </SectionContent>

                  <ArticleTitle>제5조 (정보의 게시 및 관리)</ArticleTitle>
                  <SectionContent>
                    ① 누구든지 사이트에 허위 정보, 음란하거나 폭력적인 정보,
                    다른 사람의 권리를 침해하는 정보, 기타 법령 및 선량한
                    사회질서에 위반하는 정보를 게시해서는 안됩니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 회원이 게시한 정보가 제1항에 위배된
                    정보라고 판단하는 경우에는 사전 통지 없이 그 정보를
                    삭제하거나 게시를 거부할 수 있습니다. 다만 더 에이치 황해가
                    게시된 모든 정보를 검토할 의무가 있는 것은 아닙니다.
                    <br />
                    <br />③ 제1항을 위반하는 정보를 게시함으로 인해 발생한
                    책임은 전적으로 그 정보를 게시한 회원이 부담합니다.
                  </SectionContent>
                </Section>

                <Section>
                  <ArticleTitle>제6조 (정보로 인한 권리침해)</ArticleTitle>
                  <SectionContent>
                    ① 사이트 또는 앱에 게시된 정보로 인한 권리침해를 주장하는
                    사람 또는 단체는 정보통신망 이용촉진 및 정보보호 등에 관한
                    법률, 저작권법 등에 따라 해당 정보의 삭제를 요청할 수
                    있습니다. 이 경우 더 에이치 황해는 관련 법령에 따라
                    조치합니다.
                    <br />
                    <br />② 권리침해를 주장하는 사람 또는 단체의 요청이 없더라도
                    더 에이치 황해는 관련 법령에 따라 정보에 대해 접근차단 등의
                    조치를 취할 수 있습니다.
                  </SectionContent>

                  <ArticleTitle>
                    제7조 (게시물의 저작권과 저작물의 이용)
                  </ArticleTitle>
                  <SectionContent>
                    ① 회원이 사이트 또는 앱에 게시한 게시물의 저작권은 그
                    게시물을 게시한 회원에게 있습니다.
                    <br />
                    <br />
                    ② 사이트상 게시물은 더 에이치 황해가 제공하는 여러 서비스에
                    노출될 수 있습니다. 게시물에 대해 저작권을 가진 회원은 더
                    에이치 황해에게 서비스의 제공, 마케팅, 홍보 및 새로운
                    서비스를 개발하기 위해 필요한 범위 내에서 사용, 저장, 수정,
                    복제, 공중송신, 전시, 배포, 2차저작물작성 등의 방식으로
                    이용할 수 있도록 그 저작물의 이용을 허락하는 전 세계적인
                    라이선스를 제공합니다.
                    <br />
                    <br />③ 회원은 더 에이치 황해에 제공한 게시물에 대해 더
                    에이치 황해에 라이선스를 부여하기 위해 필요한 권리를
                    보유해야 합니다. 이러한 권리를 보유하지 않아 발생하는 모든
                    문제에 대해서는 게시물을 게시한 회원이 책임을 부담하게
                    됩니다.
                  </SectionContent>

                  <ArticleTitle>제8조 (커뮤니티 이용과 책임)</ArticleTitle>
                  <SectionContent>
                    ① 더 에이치 황해는 회원들이 공통의 관심사를 공유할 수 있는
                    커뮤니티 서비스를 운영할 수 있습니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 제4조에 따라 커뮤니티 서비스를 중단할 수
                    있습니다.
                    <br />
                    <br />
                    ③ 더 에이치 황해는 커뮤니티를 검열할 의무를 부담하지 않으며,
                    커뮤니티상의 정보를 관리하지 않습니다. 더 에이치 황해는
                    커뮤니티에 관한 책임 및 회원이 커뮤니티에 참여함으로써
                    발생하는 어떠한 사건에 대한 책임도 지지 않습니다.
                    <br />
                    <br />
                    ④ 회원은 다른 사람의 권리를 침해하거나 선량한 사회질서에
                    위반하는 방식 또는 내용으로 커뮤니티를 개설하여 운영하여서는
                    아니 됩니다.
                    <br />
                    <br />⑤ 더 에이치 황해는 커뮤니티가 제3항에 위배되어
                    운영된다고 판단하는 경우에는 사전 통지 없이 그 커뮤니티를
                    삭제하거나 접근을 차단할 수 있습니다. 다만 더 에이치 황해가
                    모든 커뮤니티를 검토할 의무가 있는 것은 아닙니다.
                  </SectionContent>

                  <ArticleTitle>제9조 (서비스 이용상의 의무)</ArticleTitle>
                  <SectionContent>
                    ① 누구든지 서비스를 이용하면서 다음 각 호의 행위를 해서는
                    아니 됩니다.
                    <br />
                    <br />
                    1. 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른
                    사람의 계정 및 비밀번호를 도용 또는 부정하게 사용하거나,
                    다른 사람의 명의를 사용하거나 명의자의 허락 없이 본인확인
                    등을 수행하는 행위
                    <br />
                    2. 더 에이치 황해의 서비스를 이용하여 얻은 정보를 더 에이치
                    황해의 사전 서면 동의 없이 복제 또는 유통시키거나 상업적으로
                    이용하는 행위
                    <br />
                    3. 다른 사람의 명예를 훼손하거나 허위 사실을 게시하는 등
                    권리를 침해하는 행위
                    <br />
                    4. 앱 또는 사이트에 음란물을 게시하거나 음란사이트를
                    연결(링크)하는 행위
                    <br />
                    5. 더 에이치 황해 또는 제3자의 저작권 등 기타 권리를
                    침해하는 행위(국내외 제3자의 저작권 등을 침해하는 행위로서
                    더 에이치 황해가 IP 접속 차단 등 기술적인 조치를 통하여
                    타인에 대한 권리 침해 방지 조치를 취하였음에도 불구하고
                    이용자가 더 에이치 황해를 기망하는 수단과 방법 등을 통하여
                    서비스에 접속 하는 등 제3자의 저작권 등을 침해하는 행위를
                    포함합니다)
                    <br />
                    6. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형,
                    음성 등을 타인에게 유포하는 행위
                    <br />
                    7. 사이트 또는 앱의 오동작이나 정보 등의 파괴 및 혼란을
                    유발시킬 수 있는 행위
                    <br />
                    8. 사이트 또는 앱의 운영을 방해하거나 안정적 운영을 방해할
                    수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 또는
                    수신자의 명시적인 동의 없이 광고성 정보 또는 스팸메일(Spam
                    Mail)을 전송하는 행위
                    <br />
                    9. 더 에이치 황해의 동의 없이 서비스 또는 이에 포함된
                    소프트웨어의 일부를 복사, 수정, 배포, 판매, 양도, 대여,
                    담보제공하거나 타인에게 그 이용을 허락하는 행위와
                    소프트웨어를 역설계하거나 소스 코드의 추출을 시도하는 등
                    서비스를 복제, 분해 또는 모방하거나 기타 변형하는 행위
                    <br />
                    10. 타인으로 가장하는 행위 및 타인과의 관계를 허위로
                    명시하는 행위
                    <br />
                    11. 서비스 이용자의 개인정보를 수집, 저장, 공개하는 행위
                    <br />
                    12. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게
                    손해를 가하는 등 피해를 입힐 목적으로 허위의 정보를 게시하는
                    행위
                    <br />
                    13. 재물을 걸고 도박하거나 사행행위를 하는 행위
                    <br />
                    14. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를
                    유통시키는 행위
                    <br />
                    15. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향,
                    글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여
                    상대방의 일상적 생활을 방해하는 행위
                    <br />
                    16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는
                    정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위
                    <br />
                    17. 더 에이치 황해 또는 관계사의 직원이나 운영자를
                    가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을
                    게시하거나 E-mail, 메시지 등을 발송하는 행위
                    <br />
                    18. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인
                    가동을 방해, 파괴할 가능성이 있는 소프트웨어 바이러스, 기타
                    다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를
                    게시하거나 E-mail, 카카오톡 메시지 등으로 발송하는 행위
                    <br />
                    19. 스토킹(stalking), 허위 또는 악의적 신고 남용 등 다른
                    이용자를 괴롭히는 행위
                    <br />
                    20. 기타 현행 법령, 본 약관 및 운영정책 등 더 에이치 황해가
                    제공하는 서비스 관련 세부지침을 위반하는 행위
                    <br />
                    <br />
                    ② 누구든지 제1항에서 정한 서비스 이용상의 의무 또는 관련
                    법령을 위반한 경우에는 서비스 이용이 제한되거나 가입이
                    취소되거나 재가입이 금지될 수 있습니다.
                    <br />
                    <br />③ 회원은 가입 시 제공한 정보가 변경된 경우 사이트를
                    통하여 변경된 정보를 더 에이치 황해에 제공하여야 합니다.
                  </SectionContent>
                </Section>

                <Section>
                  <ArticleTitle>제10조 (더 에이치 황해의 의무)</ArticleTitle>
                  <SectionContent>
                    ① 더 에이치 황해는 법령과 이 약관이 정하는 권리의 행사와
                    의무의 이행을 신의에 좇아 성실하게 하여야 합니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 회원이 안전하게 서비스를 이용할 수 있도록
                    개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야
                    하며 개인정보처리방침을 게시하고 준수합니다.
                    <br />
                    <br />③ 더 에이치 황해는 서비스를 이용하는 이용자로부터
                    제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를
                    지체없이 처리합니다. 이용자가 제기한 의견이나 불만사항에
                    대해서는 전자우편 등을 통하여 그 처리과정 및 결과를
                    전달합니다.
                  </SectionContent>

                  <ArticleTitle>제11조 (개인정보 보호)</ArticleTitle>
                  <SectionContent>
                    ① 더 에이치 황해는 개인정보를 처리하는 경우 관련 법령을
                    준수합니다.
                    <br />
                    <br />② 더 에이치 황해는 개인정보처리방침을 수립하여
                    공개하고, 이를 준수하기 위해 노력합니다.
                  </SectionContent>
                </Section>

                <Section>
                  <SectionTitle>제3장 기타</SectionTitle>

                  <ArticleTitle>제12조 (손해배상 및 면책)</ArticleTitle>
                  <SectionContent>
                    ① 더 에이치 황해는 사이트 및 앱에 정확한 정보를 제공하기
                    위해 노력합니다. 그러나 더 에이치 황해는 사이트 및 앱에
                    게시된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해 보증하지
                    않습니다. 누구든지 사이트에 게시된 정보, 자료 등을 임의로
                    이용하여 발생한 손해에 대해 더 에이치 황해에게 책임을 물을
                    수 없습니다.
                    <br />
                    <br />
                    ② 더 에이치 황해는 서비스 이용에 따라 이용자가 기대하는
                    어떠한 이익이나 결과를 보증하지 않습니다. 더 에이치 황해가
                    제공하는 서비스와 관련하여 손해가 발생하더라도 더 에이치
                    황해는 책임을 지지 않습니다. 다만 황해의 고의에 의한
                    범죄행위로 인한 경우에는 그로 인해 발생한 손해에 대해 책임을
                    부담합니다.
                    <br />
                    <br />③ 더 에이치 황해는 회원 또는 제3자에 의해 게시된
                    정보를 승인, 수정, 반대할 의무가 없습니다. 더 에이치 황해는
                    서비스 이용자 사이 또는 서비스 이용자와 제3자 사이에 서비스
                    이용과 관련하여 발생한 분쟁에 대해 개입할 의무가 없으며 그와
                    관련하여 발생한 손해를 배상할 책임이 없습니다.
                  </SectionContent>

                  <ArticleTitle>제13조 (앱과 관련된 소유권)</ArticleTitle>
                  <SectionContent>
                    ① 더 에이치 황해가 제공하는 서비스, 그에 필요한 소스코드,
                    이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과
                    관련된 지적재산권 기타 권리는 더 에이치 황해에 귀속됩니다.
                    <br />
                    <br />② 누구든지 더 에이치 황해의 사전 서면 동의 없이 더
                    에이치 황해에 귀속된 권리를 이용할 수 없습니다.
                  </SectionContent>

                  <ArticleTitle>제14조 (분쟁의 해결)</ArticleTitle>
                  <SectionContent>
                    서비스를 이용함에 있어 분쟁이 발생한 경우 더 에이치 황해는
                    이를 원만히 해결하기 위해 최선을 다합니다. 그럼에도 해결되지
                    않는 경우 중재법에 따른 중재에 의한 해결을 시도하며, 중재를
                    원하지 않는 경우 민사소송법에 따라 소를 제기할 수 있습니다.
                    중재 또는 소송에 의한 분쟁해결 시 준거법은 대한민국 법으로
                    합니다.
                  </SectionContent>
                </Section>

                <FooterSection>
                  <EnforcementDate>
                    공고일자 2025년 4월 30일
                    <br />
                    시행일자 2025년 4월 30일
                  </EnforcementDate>
                </FooterSection>

                <CheckboxContainer onClick={() => setAgreed(!agreed)}>
                  <CheckboxImage
                    src={
                      agreed ? "/png/checked.png" : "/png/checkedinActive.png"
                    }
                    alt="체크박스"
                  />
                  <CheckboxLabel>이용약관에 동의합니다 (필수)</CheckboxLabel>
                </CheckboxContainer>

                <SignatureDate>
                  {new Date().toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </SignatureDate>
              </SectionContainer>
            </ModalBody>
            <ModalFooter>
              <ConfirmButton onClick={handleConfirm} disabled={!agreed}>
                동의하고 계속하기
              </ConfirmButton>
            </ModalFooter>
          </ModalContainer>
        )}
      </AnimatePresence>
    </ModalOverlay>
  );
};

// 스타일 컴포넌트
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 999;
  touch-action: none;

  @media (min-width: 769px) {
    align-items: center;
  }
`;

const ModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 500px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  @media (min-width: 769px) {
    border-radius: 16px;
    max-width: 420px;
    max-height: 90vh;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  text-align: center;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  padding: 0;
  margin: 0;
  cursor: pointer;
`;

const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  font-size: 14px;
  line-height: 1.6;
`;

const ModalFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 0 14px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${(props) => (props.disabled ? "#E5E5E5" : "#0075ff")};
  color: ${(props) => (props.disabled ? "#999" : "white")};
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  border: none;
  opacity: ${(props) => (props.disabled ? 0.8 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const TermsTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
`;

const IntroText = styled.p`
  margin-bottom: 20px;
  line-height: 1.6;
`;

const SectionContainer = styled.div`
  margin-bottom: 20px;
`;

const Section = styled.div`
  margin-bottom: 25px;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
`;

const ArticleTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const SectionContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #444;
  white-space: pre-line;
  margin-bottom: 15px;
`;

const SignatureDate = styled.div`
  width: 100%;
  text-align: right;
  font-size: 14px;
  margin-top: 20px;
  font-weight: 500;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;
`;

const CheckboxImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const CheckboxLabel = styled.div`
  font-size: 15px;
  font-weight: 500;
`;

const FooterSection = styled.div`
  width: 100%;
  margin-top: 20px;
  text-align: center;
`;

const EnforcementDate = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
`;

export default ElectronicSignature3;
